import React from "react";

export const Layout = ({ children }) => {
  return (
    <div className="bg-white h-screen flex place-items-center items-center justify-center w-[100%]">
      {children}
    </div>
  );
};
